import axios from 'axios';
import Authorization from './Authorization';

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_CMS_API_ROUTE,
  headers: {
    Accept: process.env.VUE_APP_CMS_API_ACCEPTS
  },
});

HTTP.interceptors.request.use(function (config) {
  config.headers.Authorization = `bearer ${Authorization.getToken()}`
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

export default HTTP;
